(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5189],{

/***/ 95189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content060": function() { return /* binding */ Content060; },
  "default": function() { return /* binding */ Content060_Content060; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/components/LazyRenderingButton/index.js + 3 modules
var LazyRenderingButton = __webpack_require__(41141);
// EXTERNAL MODULE: ./src/components/widgets/content/Content060/Content060.module.scss
var Content060_module = __webpack_require__(89543);
var Content060_module_default = /*#__PURE__*/__webpack_require__.n(Content060_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/content/Content060/StudentsList/StudentsList.module.scss
var StudentsList_module = __webpack_require__(43269);
var StudentsList_module_default = /*#__PURE__*/__webpack_require__.n(StudentsList_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content060/StudentsList/StudentsList.jsx










var StudentsList = function(param) {
    var students = param.students;
    var limit = (0,LazyRenderingButton/* useLazyRenderingState */.vO)().limit;
    var ref = (0,react.useState)(null), currentVideo = ref[0], setCurrentVideo = ref[1];
    var push = (0,router.useRouter)().push;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var slicedStudents = (0,react.useMemo)(function() {
        return students.slice(0, limit);
    }, [
        limit,
        students
    ]);
    var selectVideo = (0,react.useCallback)(function(link) {
        return function() {
            var video = (0,utils/* parseYouTubeId */.Us)(link);
            if (video) {
                setCurrentVideo(video);
                return;
            }
            if (link) {
                push(link);
            }
        };
    }, [
        push
    ]);
    var clearVideo = (0,react.useCallback)(function() {
        setCurrentVideo(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (StudentsList_module_default()).items,
                children: slicedStudents.map(function(item) {
                    var video = (0,utils/* parseYouTubeId */.Us)(item.videoLink);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                        onClick: selectVideo(item.videoLink),
                        className: classnames_default()((StudentsList_module_default()).item, (0,_define_property/* default */.Z)({}, (StudentsList_module_default())["non-pointer"], !item.videoLink)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                                    image: item.photo,
                                    className: (StudentsList_module_default()).image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (StudentsList_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading7 */.Pb, {
                                            color: "light",
                                            className: (StudentsList_module_default()).title,
                                            children: item.title
                                        }),
                                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (StudentsList_module_default()).bottom,
                                            children: [
                                                video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (StudentsList_module_default()).button,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                        name: "play",
                                                        theme: "accent"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (StudentsList_module_default()).text,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                            color: "light",
                                                            appearance: "bold",
                                                            className: (StudentsList_module_default()).name,
                                                            children: item.fullName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                                            color: "light",
                                                            uppercase: true,
                                                            className: (StudentsList_module_default()).position,
                                                            children: item.position
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, item.id);
                })
            }),
            currentVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalWrapper */.AB, {
                onCloseModal: clearVideo,
                appearance: "full-area",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* YoutubeVideo */.tL, {
                    id: currentVideo
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content060/StudentsList/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content060/Content060.jsx






var Content060 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.caption) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var interviews = (ref2 = payload === null || payload === void 0 ? void 0 : payload.interviews) !== null && ref2 !== void 0 ? ref2 : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content060_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content060_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Content060_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                                className: (Content060_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                color: "grey",
                                value: description,
                                className: (Content060_module_default()).description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyRenderingButton/* LazyRenderingProvider */.Bv, {
                        size: interviews.length,
                        initialLimit: 4,
                        incrementBy: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Content060_module_default()).items,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudentsList, {
                                    students: interviews
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LazyRenderingButton */.WJ, {})
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Content060_Content060 = (Content060);


/***/ }),

/***/ 89543:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content060_wrapper__X1HVl","top":"Content060_top__GLDc6","title":"Content060_title__jaIA6","description":"Content060_description__Gq1sx"};

/***/ }),

/***/ 43269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"items":"StudentsList_items__Yr4PU","item":"StudentsList_item__swJ6F","non-pointer":"StudentsList_non-pointer__PAo_t","image":"StudentsList_image__Tm017","content":"StudentsList_content__1xAaS","title":"StudentsList_title__mUROP","name":"StudentsList_name__Ld_eA","position":"StudentsList_position__ozWAS","bottom":"StudentsList_bottom__2wrKn","text":"StudentsList_text__1Oeok","button":"StudentsList_button__1Hcz0"};

/***/ })

}]);